
export const environment = {

  production: false,
  server: {
    mainURL: 'https://test.avs-api.com/delivery-ops/',
    domain: 'https://test-delivery-ops.avsemprize.com/',
    key: 'a3a625d133af5abf650ba9c701381d9c',
    project: 'delivery_ops',
    auth_token: 'do_token'
  },
};
